/* global axios */

const baseUrl = accountId => `/api/v1/accounts/${accountId}/lilith/knowledge`;
const scopedParams = (assistantId, params = {}) => ({
  ...params,
  assistant_id: assistantId,
});
const scopedData = (assistantId, data = {}) => ({
  ...data,
  assistant_id: assistantId,
});

export const getLilithFaqs = (accountId, assistantId, params = {}) =>
  axios.get(`${baseUrl(accountId)}/faqs`, {
    params: scopedParams(assistantId, params),
  });

export const getLilithFaqDrilldown = (
  accountId,
  assistantId,
  id,
  params = {}
) =>
  axios.get(`${baseUrl(accountId)}/faqs/${id}/drilldown`, {
    params: scopedParams(assistantId, params),
  });

export const getLilithSuggestions = (accountId, assistantId, params = {}) =>
  axios.get(`${baseUrl(accountId)}/suggestions`, {
    params: scopedParams(assistantId, params),
  });

export const getLilithSuggestion = (accountId, assistantId, id) =>
  axios.get(`${baseUrl(accountId)}/suggestions/${id}`, {
    params: scopedParams(assistantId),
  });

export const createLilithFaq = (accountId, assistantId, data) =>
  axios.post(`${baseUrl(accountId)}/faqs`, scopedData(assistantId, data));

export const updateLilithFaq = (accountId, assistantId, id, data) =>
  axios.patch(
    `${baseUrl(accountId)}/faqs/${id}`,
    scopedData(assistantId, data)
  );

export const deleteLilithFaq = (accountId, assistantId, id) =>
  axios.delete(`${baseUrl(accountId)}/faqs/${id}`, {
    data: scopedData(assistantId),
  });

export const bulkDeleteLilithFaqs = (accountId, assistantId, ids) =>
  axios.post(
    `${baseUrl(accountId)}/faqs/bulk/delete`,
    scopedData(assistantId, { ids })
  );

export const updateLilithSuggestion = (accountId, assistantId, id, data) =>
  axios.patch(
    `${baseUrl(accountId)}/suggestions/${id}`,
    scopedData(assistantId, data)
  );

export const runLilithSuggestionAction = (
  accountId,
  assistantId,
  id,
  action,
  expectedRevision
) =>
  axios.post(
    `${baseUrl(accountId)}/suggestions/${id}/${action}`,
    scopedData(assistantId, { expected_revision: expectedRevision })
  );

export const getLilithDocuments = (accountId, assistantId, params = {}) =>
  axios.get(`${baseUrl(accountId)}/documents`, {
    params: scopedParams(assistantId, params),
  });

export const getLilithDocument = (accountId, assistantId, id) =>
  axios.get(`${baseUrl(accountId)}/documents/${id}`, {
    params: scopedParams(assistantId),
  });

export const getLilithDocumentFaqs = (
  accountId,
  assistantId,
  id,
  params = {}
) =>
  axios.get(`${baseUrl(accountId)}/documents/${id}/faqs`, {
    params: scopedParams(assistantId, params),
  });

export const getLilithDocumentUsage = (
  accountId,
  assistantId,
  id,
  params = {}
) =>
  axios.get(`${baseUrl(accountId)}/documents/${id}/usage`, {
    params: scopedParams(assistantId, params),
  });

export const createLilithWebsiteDocument = (accountId, assistantId, data) =>
  axios.post(
    `${baseUrl(accountId)}/documents/website`,
    scopedData(assistantId, data)
  );

export const createLilithFileDocument = (
  accountId,
  assistantId,
  file,
  name = ''
) => {
  const data = new FormData();
  data.append('file', file);
  data.append('assistant_id', assistantId);
  if (name) data.append('name', name);
  return axios.post(`${baseUrl(accountId)}/documents/file`, data);
};

export const deleteLilithDocument = (accountId, assistantId, id) =>
  axios.delete(`${baseUrl(accountId)}/documents/${id}`, {
    data: scopedData(assistantId),
  });

export const bulkDeleteLilithDocuments = (accountId, assistantId, ids) =>
  axios.post(
    `${baseUrl(accountId)}/documents/bulk/delete`,
    scopedData(assistantId, { ids })
  );

export const syncLilithDocument = (accountId, assistantId, id) =>
  axios.post(
    `${baseUrl(accountId)}/documents/${id}/sync`,
    scopedData(assistantId)
  );

export const retryLilithDocument = (accountId, assistantId, id) =>
  axios.post(
    `${baseUrl(accountId)}/documents/${id}/retry`,
    scopedData(assistantId)
  );

export const bulkSyncLilithDocuments = (accountId, assistantId, ids) =>
  axios.post(
    `${baseUrl(accountId)}/documents/bulk/sync`,
    scopedData(assistantId, { ids })
  );
